module.exports = __webpack_public_path__ + "static/media/opiniones-banner.967e19bb.png";